module.exports = __webpack_public_path__ + "fonts/1aca8d1.ttf";